module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/#top"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.png",
      "alt": "brand"
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [(this.$locale.current() === 'fr' || this.$locale.current() === null) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.changeLang('en')
      }
    }
  }, [_c('b', [_vm._v("EN")])]) : (this.$locale.current() === 'en') ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.changeLang('fr')
      }
    }
  }, [_c('b', [_vm._v("FR")])]) : _vm._e()]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/#top"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.home')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/#intro"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.about')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/#influenceur"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.influenceur')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/#quizz"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.quizz')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "faq"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.faq')))])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://chaperon.tunetoo.com",
      "alt": "chaperon boutique",
      "title": _vm.$t('Header.shop-title'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('Header.shop')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://blog.chaperon.me",
      "alt": "chaperon boutiquele blog",
      "title": _vm.Blog,
      "target": "_blank"
    }
  }, [_vm._v("Blog")])])])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "footer__primary"
  }, [_c('div', {
    staticClass: "footer__blocks"
  }, [_c('h5', [_vm._v("Pandaaz")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.pandaaz.com",
      "target": "_blank",
      "alt": "Pandaaz",
      "title": "Pandaaz createur de l'app Chaperon"
    }
  }, [_vm._v(_vm._s(_vm.$t('Footer.about')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer__blocks"
  }, [_c('h5', [_vm._v("Support ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "/terms",
      "alt": "terms",
      "title": "conditions générales"
    }
  }, [_vm._v(_vm._s(_vm.$t('Footer.terms')))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/privacy",
      "alt": "privacy",
      "title": "confidentialité"
    }
  }, [_vm._v(_vm._s(_vm.$t('Footer.privacy')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer__secondary text-center"
  }, [_c('ul', [_c('li', [_vm._v(" \n                      ")]), _vm._v(" "), _c('li', [_vm._v(" \n                      ")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sprite-insta",
    attrs: {
      "href": "https://www.instagram.com/chaperon_me",
      "alt": "chaperon instragram",
      "title": _vm.$t('Footer.chaperon-insta'),
      "target": "_blank"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sprite-fb",
    attrs: {
      "href": "https://www.facebook.com/chaperon.me",
      "alt": "chaperon facebook",
      "title": _vm.$t('Footer.chaperon-fb'),
      "target": "_blank"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('li', [_vm._v(" \n                      ")])]), _vm._v(" "), _c('span', [_vm._v("©Copyright 2015 Chaperon.")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle collapsed",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "false",
      "aria-controls": "navbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65f229fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 68
// module chunks = 0